<script>
import 'vue-select/dist/vue-select.css'
import axios from 'axios'
import { axiosGetPost } from '@router/axiosGetPost'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'
import Multiselect from 'vue-multiselect'
import store from '@state/store'

export default {
  name: 'CarrierCreate',
  components: { vueDropzone: vue2Dropzone, Multiselect },
  data() {
    return {
      loading: false,
      carrierName: '',
      variations: [],
      new_variation: null,
      selectedOptions: {
        fileName: null,
        dropzoneOptions: {
          url: process.env.VUE_APP_RUTA_API + 'cargofive/upload_carrier_img',
          thumbnailWidth: 150,
          maxFilesize: 10.0,
          dictDefaultMessage:
            "<i class='uil uil-cloud-upload'></i> Upload File",
          maxFiles: 1,
          addRemoveLinks: true,
          headers: {
            Authorization: store.state.auth.currentUser.token,
          },
        },
      },
    }
  },
  computed: {
    name_field() {
      return (this.variations[0] = this.carrierName)
    },
  },
  methods: {
    save() {
      if (this.validateFields()) {
        this.loading = true
        axiosGetPost('post', '/cargofive/carriers/create', {
          name: this.carrierName,
          varation: this.variations.filter((item) => item),
          image: this.selectedOptions.fileName,
        }).then((response) => {
          if (response.success) {
            this.$toastr.s('Success. Carrier saved')
          } else {
            this.$toastr.e('Attention. Error' + response.message)
          }
          this.loading = false
          this.$emit('update_view')
          this.$emit('close_modal')
          return response
        })
      }
    },
    newElement(variable) {
      let data = variable == 'variations' ? null : [null, null]
      this[variable].push(data)
      console.log(this.variations)
    },
    dropElement(index, variable) {
      this[variable].splice(index, 1)
      console.log(this.variations)
    },
    removeFile() {
      const dataDic = {
        filename: this.selectedOptions.fileName,
      }
      axiosGetPost('post', '/cargofive/delete_file', dataDic).then(
        (response) => {
          let data = response.data
          if (data.success === true) {
            this.selectedOptions.fileName = null
          } else {
            this.selectedOptions.fileName = null
            this.$toastr.e('Error Delete in Server. Error: ' + data.error)
          }
          return data
        }
      )
    },
    vsuccess(file, response) {
      this.selectedOptions.fileName = response.file_name
    },
    validateFields() {
      let bool = true
      if (!this.carrierName) {
        this.$toastr.e('Attention. Fill field Name')
        bool = false
      }
      if (!this.selectedOptions.fileName) {
        this.$toastr.e('Attention. Send an Image')
        bool = false
      }
      if (!this.variations.every((element) => element)) {
        this.$toastr.e('Attention. Fill all fields on variations')
        bool = false
      }
      return bool
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loading"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group">
        <div class="form-group">
          <div class="col-md-12 row">
            <div class="col-md-6">
              <label class="mb-1 mt-0" for="name-name">Name: </label>
              <b-form-input
                :id="'name-name'"
                v-model="carrierName"
                value
                @change="name_field"
                :placeholder="'Write value name'"
              ></b-form-input>
            </div>
          </div>

          <div class="col-md-12 row">
            <div class="col-md-4">
              <label class="mb-1 mt-0" for="default"></label>
              <label class="mb-1 mt-0" for="default">Variations</label>
            </div>
          </div>
          <div class="col-md-12 row">
            <div
              class="col-md-4"
              v-for="(v, index) in variations"
              v-bind:key="index"
            >
              <div class="input-group mb-3">
                <b-form-input
                  v-model="variations[index]"
                  value
                  :placeholder="'Write value '"
                  class="form-control"
                ></b-form-input>
                <div
                  class="input-group-prepend"
                  @click="dropElement(index, 'variations')"
                >
                  <span class="input-group-text">x</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-sm mt-0 btn-outline-secondary form-control"
              title="New variation"
              @click="newElement('variations')"
            >
              <i class="uil uil-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-md-12 row">
          <div class="col-xl-12 col-sm-12">
            <div class="form-group mt-1 mt-sm-0">
              <vue-dropzone
                id="dropzone"
                ref="myVueDropzone"
                :options="selectedOptions.dropzoneOptions"
                :destroyDropzone="false"
                @vdropzone-removed-file="removeFile"
                @vdropzone-success="vsuccess"
              >
                <div class="text-center">
                  <i class="h1 text-muted uil-cloud-upload"></i>
                  <h3>Drop files here or click to upload.</h3>
                  <span class="text-muted font-size-13">
                    (This is just a demo dropzone. Selected files are
                    <strong>not</strong> actually uploaded.)
                  </span>
                </div>
              </vue-dropzone>
            </div>
          </div>
        </div>

        <div class="col-md-12 row">
          <div class="col-md-12">
            <b-button
              variant="primary"
              class="form-control col-4"
              @click="save()"
              >Save</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>